import { IFactory } from "../../varibles/interface";
import { createSliceSelectors } from "../selectors";

export const NAME_SLICE = 'factory'

export interface FactoryState {
    data: IFactory[]
    factoriesAdmin: IFactory[]

    loading: boolean
}

export const initialState: FactoryState = {
    data: [],
    factoriesAdmin: [],

    loading: false,
}

export const selectFactory = createSliceSelectors(NAME_SLICE, initialState);
